export var PurchaseOrderType;
(function (PurchaseOrderType) {
    PurchaseOrderType[PurchaseOrderType["STANDARD"] = 1] = "STANDARD";
    PurchaseOrderType[PurchaseOrderType["DROP_SHIP"] = 2] = "DROP_SHIP";
    PurchaseOrderType[PurchaseOrderType["BACK_ORDER"] = 3] = "BACK_ORDER";
})(PurchaseOrderType || (PurchaseOrderType = {}));
//# sourceMappingURL=purchase-order-type.js.map